<ns-page-container sidebarHeader="Dodawaj adresatów, aby szybciej tworzyć wysyłki.">

    <ng-container page-sidebar>
        <div class="button-container" (click)="navigateToForm()">
            <div class="button">
                <ns-plus-button></ns-plus-button>
            </div>
        </div>

        <h2 class="sidebar-title" (click)="navigateToForm()">Dodaj adres do książki adresowej</h2>
    </ng-container>

    <ng-container page-content>

        <div class="list-wrapper">
            <h2>
                Książka adresowa:
            </h2>

            <div class="search">
                <input type="text"
                  [formControl]="query"
                  autocomplete="off"
                  placeholder="Wyszukaj adresata"
                />
            </div>

            <div class="list">
                <ng-container *ngFor="let header of headers;">
                    <div class="list-header">
                        {{ header }}
                    </div>
                    <div class="list-item" *ngFor="let item of groupedItems[header];">
                        <div class="list-item-main">
                            <div class="name">{{ item.firstName }} {{ item.lastName }}</div>
                            <div class="item-meta">
                                <span class="date">{{ item.email }}</span>
                                <span *ngIf="item.companyName" class="date">{{ item.companyName }}</span>
                                <span *ngIf="item.phone" class="date">tel. {{ item.phone }}</span>
                            </div>
                        </div>

                        <div class="download-wrapper">
                            <span class="item-icon pencil"
                              (click)="navigateToEditForm(item.id)"
                            ></span>
                        </div>
                        <div class="remove-wrapper">
                            <span class="item-icon"
                              (click)="removeItem(item)"
                            ></span>
                        </div>
                    </div>
                </ng-container>

                <div class="list-item" *ngIf="!items?.length">
                    Lista jest pusta
                </div>
            </div>
        </div>

    </ng-container>

</ns-page-container>
